export function unixTimeToDate(unixTimestamp: number): Date {
  return new Date(unixTimestamp * 1000);
}
